module.exports = __webpack_public_path__ + "static/img/6292_phase_function_Paper_PointsHejduk_Prediction.f424260.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6292_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 77SA
// module chunks = 0